/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_Payment_Proof_Clipboard_DeniedInputs */

const vi_tea_purchase_payment_proof_clipboard_denied = /** @type {(inputs: Tea_Purchase_Payment_Proof_Clipboard_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trình duyệt chặn truy cập clipboard. Cho phép trong Site Settings rồi thử lại.`)
};

/**

* @param {Tea_Purchase_Payment_Proof_Clipboard_DeniedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_payment_proof_clipboard_denied = /** @type {((inputs?: Tea_Purchase_Payment_Proof_Clipboard_DeniedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_Payment_Proof_Clipboard_DeniedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_payment_proof_clipboard_denied(inputs)
});